import React from 'react';
import { reglesMotDePasse } from '../auth/motDePasse';
import { COULEURS } from '../theme/charte';

/* Liste des règles sous le champ, cochées au fil de la saisie. */
const ReglesMotDePasse: React.FC<{ id: string; motDePasse: string }> = ({ id, motDePasse }) => (
  <ul id={id} className="champ__aide" style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '2px' }}>
    {reglesMotDePasse(motDePasse).map(({ ok, libelle }) => (
      <li key={libelle} style={{ color: ok ? COULEURS.succes : COULEURS.texteSecondaire }}>
        <span aria-hidden>{ok ? '✓' : '·'}</span> {libelle}{ok ? ' (respecté)' : ''}
      </li>
    ))}
  </ul>
);

export default ReglesMotDePasse;
